import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Send } from "lucide-react";

const suggestions = ["Teach me 5 HSK 1 greetings", "Explain the four tones", "Correct: 我是学生吗", "Practice ordering food in Chinese"];

export default function TutorPage() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { api.get("/tutor/history").then((r) => setMessages(r.data)).catch(() => {}); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, busy]);

  const send = async (text) => {
    const msg = (text ?? input).trim();
    if (!msg || busy) return;
    setMessages((m) => [...m, { role: "user", content: msg }]);
    setInput(""); setBusy(true);
    try {
      const { data } = await api.post("/tutor/chat", { message: msg });
      setMessages((m) => [...m, { role: "assistant", content: data.reply }]);
    } catch {
      setMessages((m) => [...m, { role: "assistant", content: "Sorry, I couldn't respond. Try again." }]);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto flex flex-col h-[calc(100vh-9rem)]">
      <div className="mb-4">
        <h1 className="font-serif text-4xl tracking-tight">AI Tutor · 老师</h1>
        <p className="text-clay">Practice Mandarin with your personal AI tutor, aligned to HSK 3.0.</p>
      </div>

      <div className="flex-1 overflow-y-auto border border-black/10 bg-white p-5 space-y-4" data-testid="tutor-messages">
        {messages.length === 0 && (
          <div className="text-center py-10">
            <div className="w-14 h-14 bg-cinnabar text-rice mx-auto flex items-center justify-center font-serif text-2xl mb-4">师</div>
            <p className="text-clay text-sm mb-6">你好! Ask me anything or try one of these:</p>
            <div className="flex flex-wrap justify-center gap-2">
              {suggestions.map((s) => (
                <button key={s} onClick={() => send(s)} className="px-3 py-2 text-xs border border-black/10 hover:border-cinnabar hover:text-cinnabar transition-colors">{s}</button>
              ))}
            </div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[80%] px-4 py-2.5 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-ink text-rice" : "bg-rice border border-black/10 text-ink"}`}>{m.content}</div>
          </div>
        ))}
        {busy && <div className="text-xs text-clay font-mono">老师 is typing…</div>}
        <div ref={endRef} />
      </div>

      <div className="mt-4 flex gap-2">
        <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
          placeholder="Type in English or 中文…" data-testid="tutor-page-input"
          className="flex-1 px-4 py-3 border border-black/10 bg-white focus:outline-none focus:ring-1 focus:ring-cinnabar" />
        <button onClick={() => send()} disabled={busy} data-testid="tutor-page-send"
          className="px-5 bg-cinnabar text-rice hover:bg-ink transition-colors disabled:opacity-60"><Send size={18} /></button>
      </div>
    </div>
  );
}
